<template>
	<div>
		<!-- <div class="left-box" :style="{'left': left2}" @click="showQrCode">微信扫一扫</div> -->
		<div class="right-box">
			<div class="tip">郑州人才小程序</div>
			<img src="../../assets/images/zzrc-qr-code.jpg" alt="image" />
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			// 是否显示二维码
			isShow: false,
			left1: "-150px",
			left2: "0px"
		};
	},
	methods: {
		showQrCode() {
			if (!this.isShow) {
				this.left1 = "0px";
				this.left2 = "150px";
			} else {
				this.left1 = "-150px";
				this.left2 = "0px";
			}
			this.isShow = !this.isShow;
		}
	}
};
</script>

<style scoped>
.left-box {
    transition: all 0.5s;
	position: fixed;
	left: 150px;
	bottom: 295px;
	display: flex;
	align-items: center;
	margin-right: 3px;
	width: 20px;
	height: 80px;
	text-align: center;
	background: #409eff;
	color: aliceblue;
	line-height: 1.1;
	z-index: 9999;
	font-size: 12px;
	cursor: pointer;
	box-shadow: 0px 1px 2px rgb(12, 59, 107);
}
.right-box {
    width: 135px;
	height: 160px;
    text-align: center;
    /* transition: all 0.5s;
	display: flex;
	justify-content: center;
	flex-direction: row;
	flex-wrap: wrap;
	align-items: center; */
	position: fixed;
	left: 0;
	bottom: 260px;
	z-index:8888888;
	background: #409eff;
}
.right-box {
	border-radius: 2px;
	box-shadow: 0px 1px 2px rgb(12, 59, 107);
}
.right-box img {
	width: 100%;
	width: 120px;
	height: 120px;
}
.tip {
	text-align: center;
	width: 100%;
	font-size: 14px;
	color: aliceblue;
}
</style>